import { req, Request } from '../Repository';
import Enumerable from 'linq';

const resource = '/codelist';

export default {
    getCodelistsByType: async (type, language = 'cs-CZ', token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/${type}?language=${language}`, token);
        });
        // TODO sort in API
        return Enumerable.from(data)
            .orderBy((i) => i.list)
            .toArray();
    },
};
